const message_errors = {
    USER_ALREADY_EXISTS: "Ｅメールアドレスはすでに使用されています。",
    END_DATE_GREATER_THAN_START_DATE: "終了日には開始日以降の日付を指定して下さい。"
};

const error_code = {
    USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
};

const fieldName = {
    NAME: "name",
    NAME_KANA: "name_kana",
    POSTAL_CODE: "postal_code",
    ADDRESS_PROVINCE: "address_province",
    address_street: "address_street",
};

const regexEmail = /[\w\-\.]+@([\w-]+\.)+[\w\-]{2,4}$/;
const regexNameKana = /^[ぁ-ゞ]+$/u;
const regexPostalCode = /^\d{3}[-]\d{4}$/;
const regexPhone = /^0[0-9]{1,4}-[0-9]{1,4}-[0-9]{3,4}$/;
const message_post_code_invalid = "郵便番号形式正しくありません。";
const message_post_code_required_dash = "ハイフン付きの数字で入力してください。";
const message_post_code_not_exist = "郵便番号が存在しません。";
const message_user_duplicate = "同じ名前と生年月日の会員がすでに登録されています";
const message_phone_required_dash = "ハイフン付きの数字で入力してください。";
const message_phone_invalid = "電話番号形式正しくありません。";
const message_fullwidth = "半角英数字で入力してください。";

module.exports = {
    message_errors,
    error_code,
    fieldName,
    regexEmail,
    regexNameKana,
    regexPhone,
    regexPostalCode,
    message_post_code_invalid,
    message_user_duplicate,
    message_post_code_not_exist,
    message_phone_invalid,
    message_phone_required_dash,
    message_post_code_required_dash,
    message_fullwidth
};
